import { vars } from "@imwebme/clay-token";
import { Flex, Typography } from "..";
import { getTextProp } from "./Text.css";
import type { TextProps } from "./Text.types";

export const Text = ({
  text,
  align,
  bold = false,
  size = "default",
  subTitle,
  ...restProps
}: TextProps) => {
  const [titleProps, subTitleProps] = getTextProp({ size, bold });

  if (subTitle)
    return (
      <Flex.Column
        {...restProps}
        textAlign={align}
        gap={vars.spacing[size === "xsmall" ? 1 : 2]}
        whiteSpace="pre"
      >
        <Typography {...titleProps}>{text}</Typography>

        {subTitle && (
          <Typography {...subTitleProps} colorToken="textSub">
            {subTitle}
          </Typography>
        )}
      </Flex.Column>
    );

  return (
    <Typography {...restProps} {...titleProps} textAlign={align}>
      {text}
    </Typography>
  );
};
